/**
 * WhatsApp forms (Meta "WhatsApp Flows", without a data endpoint): a
 * one-screen form the customer fills in inside WhatsApp - one message
 * instead of a question-and-answer exchange. Built here, published to the
 * workspace's own WhatsApp account, sent by a conversation flow's
 * "Send a form" step. Kept in sync with
 * apps/api/src/modules/whatsapp-forms/whatsapp-forms.schemas.ts.
 */
export const WHATSAPP_FORM_FIELD_TYPES = [
    { type: 'TEXT', label: 'Short text' },
    { type: 'LONG_TEXT', label: 'Long text' },
    { type: 'PHONE', label: 'Phone number' },
    { type: 'EMAIL', label: 'Email' },
    { type: 'NUMBER', label: 'Number' },
    { type: 'DATE', label: 'Date' },
    { type: 'DROPDOWN', label: 'Dropdown' },
    { type: 'CHOICE', label: 'One choice (radio)' },
    { type: 'CHECKBOXES', label: 'Several choices (checkboxes)' },
    { type: 'OPT_IN', label: 'Tick to agree' },
];
/** Field types that pick from options. */
export const OPTION_FIELD_TYPES = ['DROPDOWN', 'CHOICE', 'CHECKBOXES'];
/** Limits we keep to (Meta allows more; one readable screen is the point). */
export const WHATSAPP_FORM_LIMITS = {
    fields: 12,
    /** Meta caps text-input and dropdown labels at 20 characters. */
    label: 20,
    title: 30,
    submitLabel: 30,
    staticOptions: 20,
};
//# sourceMappingURL=whatsapp-forms.js.map